import { render } from "./OriBeta.vue?vue&type=template&id=04f1a6e3"
import script from "./OriBeta.vue?vue&type=script&lang=js"
export * from "./OriBeta.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__